import _ from "lodash";
import {
  Component,
} from "react";
import {
  Button,
} from "react-bootstrap";
import {
  Awesome,
  Checkbox,
} from "CommonComponents/bricks";
import FloatingPopup from "CommonComponents/floating-popup";
import {
  injectFunction,
} from "CommonCore/schema-util";
import store from "CommonState/store";

@store
export default class ColumnSelector extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const {
      schema,
      columnConfig,
      injects,
    } = this.props;
    const {
      open,
    } = this.state;
    return <FloatingPopup
      open={open}
      onClose={this.closeMenu}
      placement='bottom-end'
      resizeToFit
      renderTarget={ref => (
        <Button
          ref={ref}
          variant='outline-primary'
          onClick={this.toggleMenu}>
          <Awesome name='wrench' alt='Spalten wählen' />
          &#x200b;
        </Button>
      )}
      renderPopup={(ref, style) => (
        <div ref={ref} style={{ ...style, zIndex: 1090 }}>
          <div className='column-selector-popup'>
            <div className='column-selector-heading'>Spalten ein-/ausblenden</div>
            {schema.table.filter(c => !_.isObject(c.hideFromList)
              ? !c.hideFromList
              : !injectFunction(c.hideFromList, injects)()).map(c => <Checkbox
              vertical
              key={c.field}
              label={c.display}
              checked={columnConfig.hasOwnProperty(c.field) ? columnConfig[c.field] : !c.initiallyHidden}
              onChange={evt => this.toggleColumn(c, evt.target.checked)}
            />)}
            <div className='column-selector-footer'>
              <Button variant='outline-primary' onClick={this.reset}><Awesome name='undo' />&nbsp;Auf Standard zurücksetzen</Button>
            </div>
          </div>
        </div>
      )}
    />;
  }

  toggleMenu = () => {
    this.setState({ open: !this.state.open });
  };

  closeMenu = () => {
    this.setState({ open: false });
  };

  toggleColumn = ({ field }, visible) => {
    const { schema, list, setUiListColumnVisible } = this.props;
    setUiListColumnVisible(schema.syncSettingsWith || list, field, visible);
  };

  reset = () => {
    const { schema, list, setUiListColumnVisibleDefault } = this.props;
    setUiListColumnVisibleDefault(schema.syncSettingsWith || list);
  };
}
